import NextLink from 'next/link'

export const Link = ({ href, children, ...restProps }) => {
  return (
    <NextLink href={href || ''} >
      <a {...restProps}>{children}</a>
    </NextLink>
  )
}
